"use client";

import { ArrowRight, ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: metaRef,
    isVisible: metaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const dataPoints = [{
    label: "EXPERIENCE",
    value: "40+ YRS"
  }, {
    label: "COVERAGE",
    value: "NATIONWIDE"
  }, {
    label: "QUALITY",
    value: "CERTIFIED"
  }];
  return <section data-section-id="3626" id="casestudieshero" className="bg-[#F6F6F6] text-[#1B1B1B] relative min-h-screen w-full overflow-hidden">
      {}
      <div role="img" aria-label="ABCO South Electrical Construction and Design case studies, projects, and jobs" className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/industrial_facility_exterior.png)]" />
      <div className="absolute inset-0" style={{
      background: "radial-gradient(ellipse at center, hsla(0, 0%, 4%, 0.4) 0%, hsla(0, 0%, 4%, 0.85) 70%, hsla(0, 0%, 2%, 0.95) 100%)"
    }} />
      <div className="absolute inset-0 bg-[#F6F6F6]/60" />

      {}
      <div className="absolute inset-0 mix-blend-overlay opacity-30" style={{
      background: "radial-gradient(circle at 30% 40%, hsla(10, 85%, 52%, 0.15) 0%, transparent 50%)"
    }} />

      {}
      <div className="absolute top-0 left-0 right-0 h-px bg-[#1B1B1B]/20" />

      {}
      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-[1600px] flex-col px-6 pt-24 pb-32 sm:px-10 lg:px-16">
        <div className="grid flex-1 grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          {}
          <div ref={headlineRef} className={`lg:col-span-9 flex flex-col justify-center transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="mb-8 flex items-center gap-4">
              <span className="h-px w-12 bg-[#DA2F10]" />
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#1B1B1B]/70">ABCO SOUTH — EXCELLENCE In Practice</span>
            </div>

            {}
            <h1 className="font-default font-bold uppercase leading-[0.85] tracking-tight text-[#1B1B1B]">
              <span className="block text-[clamp(3.5rem,12vw,10rem)]">Case</span>
              <span className="block text-[clamp(3.5rem,12vw,10rem)] sm:pl-[8vw] lg:pl-[120px]">studies</span>
            </h1>

            {}
            

            {}
            

            {}
            <div className="mt-12 flex flex-col sm:flex-row gap-4 sm:items-center">
              <Button asChild size="lg" className="group h-14 px-8 bg-[#DA2F10] text-white font-default font-bold uppercase tracking-wider text-sm rounded-md shadow-md hover:bg-[#B94A48] transition-all duration-300">
                <Link to="/ServicesPage">
                  View Our Services
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button asChild variant="link" className="font-mono text-xs uppercase tracking-[0.25em] text-[#1B1B1B] hover:text-[#0000FE] h-14 px-2">
                
              </Button>
            </div>
          </div>

          {}
          <div ref={metaRef} className={`hidden lg:col-span-3 lg:flex items-stretch justify-end transition-all duration-1000 delay-300 ease-out ${metaVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative flex items-center">
              
              
            </div>
          </div>
        </div>

        {}
        
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-[#1B1B1B]/20" />
    </section>;
}